import './styles.scss';

import moment from 'moment';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'src/components/Button';
import styled from 'styled-components';

import { SubscriptionState, SubscriptionType, UserSession } from '../../Models';
import { SubscribeButton } from './SubscribeButton';

const translationsScope = 'components.Profile.Membership';

const ButtonsContainer = styled.div`
  width: 500px;
  margin-left: 20px;

  a {
    min-width: 100%;
    margin-top: 5px;
  }
`;

interface Props {
  readonly userInfo: UserSession;
  readonly onCancelSubscription: () => void;
}

const MembershipSettings = (props: Props) => {
  const { isSubscribed } = props.userInfo.subscription;

  return (
    <div className="MembershipSettings">
      <div className="MembershipSettings-title">
        <FormattedMessage id={`${translationsScope}.title`} />
      </div>
      {isSubscribed ? (
        <MemberComponent subscription={props.userInfo.subscription} onCancel={props.onCancelSubscription} />
      ) : (
        <UpgradeComponent userId={props.userInfo.id} email={props.userInfo.email} />
      )}
    </div>
  );
};

interface UpgradeProps {
  readonly userId: number;
  readonly email: string;
}

export enum GumroadProduct {
  monthly = 'morningpages-pro-monthly',
  yearly = 'morningpages-pro-yearly',
}

const UpgradeButtonContainer = styled.div`
  min-width: 180px;
`;

const UpgradeComponent = (props: UpgradeProps) => {
  return (
    <div className="MembershipSettings-content">
      <div className="MembershipSettings-row">
        <div className="MembershipSettings-column">
          <div className="MembershipSettings-label">
            <FormattedMessage id={`${translationsScope}.subtitle`} />
          </div>
          <div className="MembershipSettings-value">
            <FormattedMessage id={`${translationsScope}.descr`} />
          </div>
        </div>
        <ButtonsContainer>
          <UpgradeButtonContainer>
            <SubscribeButton
              product={GumroadProduct.yearly}
              messageId={`${translationsScope}.upgradeYearly`}
              color="blue"
              outline={false}
            />
          </UpgradeButtonContainer>
          <UpgradeButtonContainer>
            <SubscribeButton product={GumroadProduct.monthly} messageId={`${translationsScope}.upgradeMonthly`} />
          </UpgradeButtonContainer>
        </ButtonsContainer>
      </div>
    </div>
  );
};

interface MemberComponentProps {
  readonly subscription: SubscriptionState;
  readonly onCancel: (event: any) => void;
}

const MemberComponent = (props: MemberComponentProps) => {
  const expirationString = moment(moment(props.subscription.expiresDate).toDate()).format('DD MMM YYYY');
  const description = props.subscription.isCancelled ? (
    <FormattedMessage
      id="components.Profile.Membership.memberCancelledDescr"
      values={{ expirationDate: expirationString }}
    />
  ) : (
    <FormattedMessage id="components.Profile.Membership.memberDescr" values={{ expirationDate: expirationString }} />
  );

  const hideCancelButton = props.subscription.isCancelled || props.subscription.type === SubscriptionType.none;
  const cancelButtonHandler =
    props.subscription.type === SubscriptionType.apple ? openManageiOSSubscriptions : props.onCancel;

  return (
    <div className="MembershipSettings-content">
      <div className="MembershipSettings-row">
        <div className="MembershipSettings-column">
          <div className="MembershipSettings-label">
            <FormattedMessage id={`${translationsScope}.memberSubtitle`} />
          </div>
          <div className="ProfileSettings-value">{description}</div>
        </div>
        {!hideCancelButton && (
          <div className="ProfileSettings-button">
            <Button color="grey" outline={true} block={true} onClick={cancelButtonHandler}>
              <FormattedMessage id={`${translationsScope}.cancel`} />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

const openManageiOSSubscriptions = () => {
  window.open('https://apps.apple.com/account/subscriptions');
};

export default React.memo(MembershipSettings);



// WEBPACK FOOTER //
// ./src/components/MembershipSettings/index.tsx